/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import Header from './header'
import Footer from './footer'
import '../../styles/reset.css'
import '../../styles/theme.less'
import '../../styles/carousel.css'
// import "../styles/owl.carousel.min.css";

const Layout = props => (
    <>
        <Header header={props.header} />
        <div>
            <main>{props.children}</main>
            <footer />
        </div>
        <Footer footer={props.footer} />
    </>
)

export default Layout
